var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('div',[_c('Report')],1):_c('ozi-loading',{attrs:{"loading":true}})}
var staticRenderFns = []

export { render, staticRenderFns }